import { generateProgressTabData } from './utils';

const actionPrefix = 'CreateServiceProvider/';

export const PROGRESS_TABS = {
  HEADLINES: { numeration: 1, name: 'Headlines', marked: true },
  LOCATION: { numeration: 2, name: 'Location' },
  CONTACT: { numeration: 3, name: 'Contact' },
  CASE_STUDY: { numeration: 4, name: 'Case Study' }
};

const SET_ACTIVE_PROGRESS_TAB = `${actionPrefix}SET_ACTIVE_PROGRESS_TAB`;
const GO_TO_PREVIOUS_TAB = `${actionPrefix}GO_TO_PREVIOUS_TAB`;

export const setActiveProgressTab = selectedTabNumeration => ({
  type: SET_ACTIVE_PROGRESS_TAB,
  payload: { selectedTabNumeration }
});

export const goToPreviousTab = () => ({ type: GO_TO_PREVIOUS_TAB });

export const progressBarReducer = (newState, action) => {
  switch (action.type) {
    case SET_ACTIVE_PROGRESS_TAB:
      newState.progressTabs = generateProgressTabData(
        newState.progressTabs,
        action.payload.selectedTabNumeration
      );

      newState.activeProgressTab = action.payload.selectedTabNumeration;
      break;

    case GO_TO_PREVIOUS_TAB:
      const newActiveTab = newState.activeProgressTab - 1;
      newState.progressTabs = generateProgressTabData(
        newState.progressTabs,
        newActiveTab
      );

      newState.activeProgressTab = newActiveTab;
      break;

    default:
      return newState;
  }
};
